
<template>
    <div>

    <template  v-if="config.type=='SelectTable'">

        <l-table-view  v-if="$store.state[config.storeName]"
                :DataArr="$store.state[config.storeName]"
                :TableConfig="config.tableConfig"
                ></l-table-view>
    </template>

</div>
</template>

<script>

import { $Path,$Urlpath} from '@/config/config.js'

export default {
    props: ['config'],
    data() {
        return {
        }
    },
    created() {
    },
    computed: {

    },
    mounted () {
    },
    methods: {
    },
    watch: {
    }
}

</script>














// WEBPACK FOOTER //
// popover_item.vue?2cb9053c